import { classifyApiError, portalClient } from '../api';
import { sessionStore } from './session';

/**
 * Ending this session (P0-WEB-08, PRD §AUTH-8).
 *
 * The local state is cleared whatever the server says. If the request failed
 * because the session had already been revoked from another device, the user is
 * signed out — that is the answer they asked for. If it failed because the API
 * is unreachable, keeping them signed in locally would leave a browser holding
 * credentials it has just been told to drop, and the cookie is HttpOnly so
 * nothing here can revoke it independently.
 *
 * The one failure worth surfacing is neither of those: a 500. It is reported so
 * the caller can say the server may not have registered it, while the browser
 * has still let go.
 */
export interface SignOutResult {
  /** True when the server confirmed. False when it was cleared locally only. */
  readonly confirmed: boolean;
}

export async function signOut(): Promise<SignOutResult> {
  try {
    await portalClient().request('/v1/auth/logout', 'post');
    return { confirmed: true };
  } catch (error) {
    const failure = classifyApiError(error);
    // Already signed out server-side. Nothing went wrong.
    return { confirmed: failure.kind === 'unauthenticated' };
  } finally {
    sessionStore.clear();
  }
}
